import { createSelector } from 'reselect';

const forms = state => state.forms.forms;
const currentForm = state => state.forms.currentForm;
const currentTab = state => state.forms.currentTab;

export const selectForms = createSelector(forms, forms => forms);
export const selectCurrentForm = createSelector(currentForm, currentForm => currentForm);
export const selectCurrentTab = createSelector(currentTab, currentTab => currentTab);
